module.exports = __webpack_public_path__ + "img/profile-pic.44e751d5.jpg";